export var IdentityProviderType;
(function (IdentityProviderType) {
    IdentityProviderType["LOCAL"] = "local";
    IdentityProviderType["SAML"] = "SAML";
})(IdentityProviderType || (IdentityProviderType = {}));
